var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadershipTeamwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408.92,
    height: 317.47,
    viewBox: "0 0 408.92 317.47",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 340.157 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.778 145.2h231.7v-87.461h-231.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76.527 112.14h231.7v-87.462h-231.7z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 -21.047 350.38)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.93 127.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.253-0.146-0.505-0.292-0.758-0.438 0.253 0.146 0.505 0.292 0.758 0.438",
    fill: "#b22e4c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.49 86.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-24.152-51.868-43.731-115.85-43.731-63.982 0-115.85 19.579-115.85 43.731s51.869 43.731 115.85 43.731c63.983 0 115.85-19.579 115.85-43.731",
    fill: "#175583"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath32)",
    opacity: 0.85001
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(322.48 101.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-24.152-51.868-43.731-115.85-43.731-63.982 0-115.85 19.579-115.85 43.731s51.869 43.731 115.85 43.731c63.983 0 115.85-19.579 115.85-43.731",
    fill: "#70bde5"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath48)",
    opacity: 0.67999
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.23 68.413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-24.152-51.868-43.731-115.85-43.731-63.982 0-115.85 19.579-115.85 43.731s51.869 43.731 115.85 43.731c63.983 0 115.85-19.579 115.85-43.731",
    fill: "#1e6eac"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.42 241.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-9.592 0-17.395-7.803-17.395-17.394s7.803-17.394 17.395-17.394c9.591 0 17.394 7.803 17.394 17.394s-7.803 17.394-17.394 17.394",
    fill: "#a1c74a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.42 206.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-9.592 0-17.395 7.803-17.395 17.394s7.803 17.394 17.395 17.394c9.591 0 17.394-7.803 17.394-17.394s-7.803-17.394-17.394-17.394",
    fill: "#a1c74a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.35 239.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-9.591 0-17.394-7.803-17.394-17.394s7.803-17.394 17.394-17.394 17.394 7.803 17.394 17.394-7.803 17.394-17.394 17.394",
    fill: "#70bde5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.35 204.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-9.591 0-17.394 7.803-17.394 17.394s7.803 17.394 17.394 17.394 17.394-7.803 17.394-17.394-7.803-17.394-17.394-17.394",
    fill: "#70bde5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(246.02 185.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.599 10.125-17.495 15.339-28.728 12.563-4.048-1.001-7.598-2.876-10.532-5.353 0.465-1.013 0.885-2.052 1.255-3.117 1.42-4.08 2.047-8.352 1.866-12.696l-0.234-2.697c-0.321-1.688-4.768-17.657-6.431-23.608 4.948-16.469 12.366-41.073 16.866-55.99 1.147-3.802 6.539-3.772 7.642 0.044 6.945 24.026 21.135 73.289 21.378 75.533l0.013 0.045h-8e-3c0.536 5.029-0.344 10.316-3.087 15.276",
    fill: "#a1c74a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.89 169.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.11 0.421-0.189 0.722-0.237 0.893l-0.034 0.155-0.602 3.819c-0.474 4.782 0.046 9.454 1.403 13.798-6.263 6.823-15.948 9.959-25.193 7.674-13.524-3.342-21.527-16.382-19.354-29.361l-0.127-3e-3 0.331-1.102c0.169-0.793 14.764-49.21 21.939-72.994 1.147-3.803 6.539-3.772 7.642 0.043 4.917 17.01 13.464 46.665 18.124 63.334-2.032 6.658-3.343 11.653-3.892 13.744",
    fill: "#70bde5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.35 174.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-9e-3c0.56 5.257-0.164 10.748-2.522 16.014-6.321 14.109-22.377 21.537-37.208 17.169-15.462-4.553-24.493-19.82-21.949-35.017l-0.153-5e-3 0.4-1.327c0.21-0.987 18.938-63.104 27.245-90.641 1.147-3.802 6.538-3.772 7.641 0.043 8.04 27.798 26.238 90.919 26.54 93.71z",
    fill: "#175583"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198.29 239.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-12.942-10.491-23.433-23.433-23.433-12.941 0-23.433 10.491-23.433 23.433s10.492 23.433 23.433 23.433c12.942 0 23.433-10.491 23.433-23.433",
    fill: "#175583"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadershipTeamwork);
export default __webpack_public_path__ + "static/media/leadership_teamwork.b54c699a441d78301242c440ce19af62.svg";
export { ForwardRef as ReactComponent };